import type { ApprovalData } from 'ui-product-approvals-common';
import { captureException } from './sentryUtils';

export const assertApprovalDataResolved = (
  hookName: string,
  resolvedData: ApprovalData,
  approvableObjectId: number | undefined
): { resolvedData: NonNullable<ApprovalData>; approvableObjectId: number } => {
  if (!resolvedData) {
    const error = new Error(
      `${hookName} called before approval data has fetched`
    );
    captureException(error, {
      extra: { fingerprint: `${hookName}-called-before-resolved-data-fetched` },
    });
    throw error;
  }
  if (!approvableObjectId) {
    const error = new Error(
      `${hookName} called when no approvableObjectId has been set in ApprovalProvider`
    );
    captureException(error, {
      extra: { fingerprint: `${hookName}-called-with-no-approvableObjectId` },
    });
    throw error;
  }
  return { resolvedData, approvableObjectId };
};
